import React, { useEffect, useState } from 'react';
import Checkmark from 'components/Icons/Checkmark';
import Instructions from 'components/Instructions';
import { Link, RouteComponentProps } from '@reach/router';
import { RFC } from 'state/StateTypes';
import Loading from 'components/Loading';
import { confirmVerification } from 'state/user/UserActions';
import { getParamFromUrl, presentErrorBasedOnCode } from 'utils';
import ErrorMessage from 'components/ErrorMessage';
import { Error, ErrorCodes } from 'types';
import Container from 'components/Container';
import FormContainer from 'components/FormContainer';
import styled from 'styled-components';

const EmailConfirmationSuccess: RFC<RouteComponentProps> = () => {
   const [loading, setLoading] = useState<boolean>(true);
   const [error, setError] = useState<Partial<Error> | null>(null);

   useEffect(() => {
      (async () => {
         const email: string | undefined = getParamFromUrl(window.location.href, 'email');
         try {
            if (email) {
               await confirmVerification(email);
            }
         } catch (error) {
            //if error results from missing token it will not have a json method
            error = error.json ? await error.json() : error;
            setError(error);
         }
         setLoading(false);
      })();
   }, []);

   return loading ? (
      <Loading />
   ) : (
      <Container>
         <FormContainer>
            <>
               <CheckmarkContainer>
                  <Checkmark />
               </CheckmarkContainer>
               <Instructions>Thanks for verifying your email address!</Instructions>
               <ReturnToAccount to="/profile">Login to your account</ReturnToAccount>
            </>
            {error && <ErrorMessage>{presentErrorBasedOnCode(error.code as ErrorCodes)}</ErrorMessage>}
         </FormContainer>
      </Container>
   );
};

export default EmailConfirmationSuccess;

const CheckmarkContainer = styled.div`
   margin: 0 auto 1em auto;
   text-align: center;
`;

const ReturnToAccount = styled(Link)`
   margin: 0 auto;
   color: ${({ theme }) => theme.secondaryBlueLight};
   cursor: pointer;
   font-weight: 600;
   text-align: center;

   &:hover {
      color: ${({ theme }) => theme.secondaryBlueDark};
   }
`;
